import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { environment } from 'src/environments/environment';

export interface LogFile {
  s3PathName: string;
  name: string;
  date: string;
};

@Injectable({
  providedIn: 'root'
})
export class LogService {
  private kilnApiUrl = environment.kilnApi;

  //This is a json object structured like
  // { externalId1: LogFile[], externalId2: Logfile[]}
  public logfiles: BehaviorSubject<{}> = new BehaviorSubject<{}>({});

  constructor(
    public http: HttpClient,
  ) { }

  getLogFileNames(externalId: string) {
    if(externalId) {
      let getLogNamesUrl = `${this.kilnApiUrl}/logs/${externalId}/filenames`;

      return new Promise((resolve, reject) => {
        this.http.get(getLogNamesUrl).subscribe((logNames: LogFile[]) => {
          let logFileNames = this.logfiles.value
          logFileNames[externalId] = logNames;
          this.logfiles.next(logFileNames)
          resolve({success: true})
        }, (error) => {
          console.log(`KilnLink: Error getLogFileNames externalId: ${externalId} - ${JSON.stringify(error)}`);
          reject({success: false, message: error});
        });
      })
    } else {
      console.log(`no external id to get log files`)
    }
  }

  downloadLog(externalId: string, filename: string): Promise<any> {
    // We may not need externalID here? We could actually do
    // let downloadLogUrl = `${this.kilnApiUrl}/logs/${fileName}/download`; or something?
    let downloadLogUrl = `${this.kilnApiUrl}/logs/${externalId}/download`;
    return new Promise((resolve, reject) => {
      this.http.post(downloadLogUrl, { s3path: filename}).subscribe((response) => {
        resolve(response)
      }, (error) => {
        console.log(`KilnLink: Error downloadLog externalId: ${externalId}, fileName: ${filename} - ${JSON.stringify(error)}`);
        reject({success: false, message: error});
      });
    })
  }
}


